import React, { ReactElement } from 'react';
import { Box, SxProps } from '@mui/material';
import { COLORS } from './tokens';

export interface SkeletonBlockProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  sx?: SxProps;
}

export const SkeletonBlock = ({
  width = '100%',
  height = 16,
  radius = 0,
  sx,
}: SkeletonBlockProps): ReactElement => (
  <Box
    aria-hidden
    sx={{
      width,
      height,
      borderRadius: typeof radius === 'number' ? `${radius}px` : radius,
      backgroundColor: COLORS.skeleton,
      position: 'relative',
      overflow: 'hidden',
      '@keyframes forYouShimmer': {
        '100%': { transform: 'translateX(100%)' },
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        transform: 'translateX(-100%)',
        background:
          'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)',
        animation: 'forYouShimmer 1.4s ease-in-out infinite',
      },
      ...sx,
    }}
  />
);
